<template>
  <v-app>
    <v-main class="public-layout"><slot /></v-main>
  </v-app>
</template>

<style scoped>
.public-layout {
  background-color: var(--default-background-color);
}
</style>
